import { Component, inject, LOCALE_ID, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GlobalSpinnerComponent } from '@nx-customer-apps/components';
import { getDefaultLanguage } from './shared/i18n/language.config';

@Component({
    imports: [RouterOutlet, GlobalSpinnerComponent],
    standalone: true,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
    public translateService = inject(TranslateService);
    private readonly localeId = inject(LOCALE_ID);

    ngOnInit(): void {
        this.translateService.setDefaultLang(getDefaultLanguage());
        this.translateService.use(this.localeId);
    }
}
